import React, { useEffect } from "react";
import { defaultHandleChange } from "../../utils/handler";
import { DEFAULT_CHANGE_PASSWORD_CREDENTIALS } from "../../utils/state";
import { Snackbar } from "../../components/Snackbar";
import { DEFAULT_SNACKBAR } from "../../utils/snackbar";
/* import { ChangePasswordForm } from "../../components/LoginForm/ChangePasswordForm"; */
import { useValidToken } from "../../hooks/useValidToken";
import { fetcher } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { THEME_SEVERITY } from "../../utils/theme";
import { useTheme } from "../../contexts/ThemeContext";
import { useConfig } from "../../contexts/config";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { lang } = useAuth();
  const [credentials, setCredentials] = React.useState(DEFAULT_CHANGE_PASSWORD_CREDENTIALS);
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();
  const { config } = useConfig();
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const { data, isValid } = useValidToken(window.location.search);
  /*   console.log(data); */
  const URL = "https://aulavirtual.linkcap.cl/tipddy/services/restore-password.php/user/changepassword";
  const headers = { "Content-Type": "appplication/json" };

  React.useEffect(() => {
    lang && console.log(lang["Recovery"]);
  }, [lang]);

  useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.body.classList.add("imagen2", "bigDesktop:bg-cover");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      document.body.style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove("imagen2", "bg-auto", "bigDesktop:bg-cover");
    };
    // eslint-disable-next-line
  }, []);

  const handleSnackbar = (snack) => {
    setSnackbar(snack);
    setTimeout(() => {
      setSnackbar(DEFAULT_SNACKBAR);
    }, 2000);
  };

  const clean = () => {
    setCredentials(DEFAULT_CHANGE_PASSWORD_CREDENTIALS);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      handleSnackbar({
        visible: true,
        message: lang["Snackbars"].invalid_access,
        severity: THEME_SEVERITY.ERROR,
      });
      return;
    }
    if (credentials.password !== credentials.confirm_password) {
      handleSnackbar({
        visible: true,
        message: lang["Snackbars"].invalid_access,
        severity: THEME_SEVERITY.ERROR,
      });
      return;
    }
    try {
      setLoading(true);
      await fetcher(URL, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          password: credentials.password,
          token: data.setdata.token,
        }),
      });
      handleSnackbar({
        visible: true,
        message: lang["Snackbars"].success_change,
        severity: THEME_SEVERITY.SUCCESS,
      });
      clean();
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      console.log(error.message);
      setSnackbar({
        visible: true,
        message: lang["Snackbars"].invalid_access,
        severity: THEME_SEVERITY.ERROR,
      });
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) => defaultHandleChange(e, credentials, setCredentials);

  if (!isValid) {
    return (
      <div className="w-full h-screen  flex items-center justify-center relative overflow-hidden">
        <div className="z-10 w-full  mx-auto px-4 laptop:px-8">
          <p className="text-white text-center my-5">Token ya expiró</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {lang && (
        <div className="w-full h-screen  flex items-center justify-center relative overflow-hidden">
          {/* Main Container */}
          <div className="z-10 w-full  mx-auto px-4 laptop:px-8">
            <div className="grid grid-cols-1 laptop:grid-cols-12 gap-8 laptop:gap-12 items-center min-h-[90vh]">
              {/* Left Column - Login Form */}
              <div className="laptop:col-span-6 flex justify-center">
                <div className="relative w-full max-w-[39rem]">
                  {/* Glow Effect */}
                  <div
                    className={`absolute inset-0 bg-gradient-to-r from-[${theme?.colors.tertiary_dark || "#44BCF9"}] to-[${
                      theme?.colors.text_login_light || "#E63289"
                    }] rounded-3xl blur-xl opacity-20`}
                  ></div>

                  {/* Form Container */}
                  <div
                    className={`relative bg-gradient-to-br from-[${theme?.colors.tertiary_dark || "#8C7FC8"}] to-[${theme?.colors.text_login_light || "#7B6BC6"}] p-1 rounded-3xl`}
                  >
                    <div
                      style={{
                        backgroundColor: theme?.colors.backgroundColorBodyLogin ? theme?.colors.backgroundColorBodyLogin : "#000000",
                      }}
                      className=" rounded-[1.4rem] p-2 tablet:p-8 shadow-2xl"
                    >
                      {/* Header with Logo */}
                      <div className="text-center mb-8">
                        <div className="text-center mb-8 w-full h-[12dvh] p-3">
                          {config && config.titulo_interfaz && <h2 className="text-4xl font-semibold antialiased text-white tracking-wider pt-4">{config.titulo_interfaz}</h2>}
                          <img
                            className="h-full w-[80%] object-contain m-auto"
                            src={theme && theme.mode === "light" ? config.config.theme.theme_logo_dark : config.config.theme.theme_logo_dark}
                            alt="..."
                          />
                        </div>
                        {/* <h2 className="text-2xl font-bold text-gray-900">
                        ¡Bienvenido!
                      </h2>
                      <p className="text-gray-600 mt-2">
                        Inicia sesión para continuar
                      </p> */}
                      </div>

                      <form onSubmit={handleSubmit} method="post" className="flex flex-col h-[28rem] justify-around m-4">
                        <div className="space-y-6 pb-5">
                          <div className="mb-4">
                            <label htmlFor="email" className="block text-2xl font-medium text-zinc-200 mb-2">
                              Nueva contraseña
                            </label>
                            <input
                              type="password"
                              name="password"
                              value={credentials.password}
                              onChange={handleChange}
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-lg"
                              required
                              style={{
                                marginBottom: ".2rem",
                              }}
                            />
                          </div>

                          <div className="mb-4">
                            <label htmlFor="email" className="block text-2xl font-medium text-zinc-200 mb-2">
                              Confirmar contraseña
                            </label>
                            <input
                              type="password"
                              name="confirm_password"
                              value={credentials.confirm_password}
                              onChange={handleChange}
                              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-lg"
                              required
                              style={{
                                marginBottom: ".2rem",
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className="space-y-4 pb-4"
                          style={{
                            marginBottom: ".5rem",
                          }}
                        >
                          <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-[#44BCF9] hover:bg-[#41Bad8] text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {loading ? (
                              <div className="flex items-center justify-center">
                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                <span>Procesando...</span>
                              </div>
                            ) : (
                              lang["Recovery"].new_pass_send
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Quote and Video (Desktop only) */}
              <div className="hidden laptop:flex laptop:col-span-7 flex-col justify-center space-y-8 h-full"></div>
            </div>
          </div>
          <Snackbar severity={snackbar.severity} visible={snackbar.visible} message={snackbar.message} />
        </div>
      )}
    </>
  );
};
export default ChangePassword;
